import { render, staticRenderFns } from "./taskSub.vue?vue&type=template&id=35b13805&"
import script from "./taskSub.vue?vue&type=script&lang=js&"
export * from "./taskSub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports